import React from "react"
import ReactDOM from "react-dom"
import { AnimatePresence } from "framer-motion"
import { BulkActionsHeader } from "src/frontend/components/OS/Applications/Shared/Accounting/BulkActions/BulkActionsHeader"
import { BulkActionField } from "src/frontend/components/OS/Applications/Shared/Accounting/BulkActions/types"
import { type TableVariant } from "src/frontend/components/Shared/Transactions/types"
import { useTransactionUpdatesHeaderRoot } from "src/frontend/components/Shared/Transactions/Updates/Headers/useTransactionUpdatesHeaderRoot"
import { useTransactionsUpdates } from "src/frontend/components/Shared/Transactions/Updates/TransactionsUpdatesContext"

interface HeaderProps {
  variant?: TableVariant
}

export const BulkTransactionUpdates: React.FC<HeaderProps> = ({ variant }) => {
  const root = useTransactionUpdatesHeaderRoot()
  const { updating, isBulkSelecting, selectedTransactions, applyBulkUpdates, clearUpdates } =
    useTransactionsUpdates()

  const isBanksAndCards = variant === "banksAndCards"
  const isTaxes = variant === "taxes"

  const supportedFields = React.useMemo(() => {
    if (isTaxes) return new Set([BulkActionField.TaxStatus])
    return new Set([
      BulkActionField.Party,
      BulkActionField.SplitCategory,
      ...(isBanksAndCards ? [] : [BulkActionField.Category]),
    ])
  }, [isBanksAndCards, isTaxes])

  const customLabels = React.useMemo(
    () =>
      isBanksAndCards
        ? {
            [BulkActionField.SplitCategory]: "Category",
          }
        : undefined,
    [isBanksAndCards]
  )

  return ReactDOM.createPortal(
    <AnimatePresence>
      {isBulkSelecting && (
        <BulkActionsHeader
          disabled={updating}
          fields={supportedFields}
          customLabels={customLabels}
          selectedTransactions={Array.from(selectedTransactions.values())}
          onUpdate={applyBulkUpdates}
          onCancel={clearUpdates}
          includeMatch
          onMatch={clearUpdates}
          includeUnmatch
          onUnmatch={clearUpdates}
        />
      )}
    </AnimatePresence>,
    root
  )
}
